function generateSessionToken() {
  let d = Date.now()
  let r

  return 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/x/g, () => {
    r = Math.floor(d + (Math.random() * 16)) % 16

    if (d) {
      d = Math.floor(d / 16)
    }

    return r.toString(16)
  })
}

export default generateSessionToken



// WEBPACK FOOTER //
// ./shared/helpers/session_tokens.js